<template>
  <li class="km__list__element--modules"
      :class="{ highlight:design === currentDesign}"
  >
    <div class="km__design__product"
         :data-designname="design"
         :data-designnametolower="designToLower(design)"
         @click="$emit('set')"
    >
      <div class="km__design__product--preview" v-lazyload>
        <img class="km__design__product--image"
             :data-src="getPreviewImageURL(design)"
             :alt="design">
      </div>
      <span class="km__design__product--description">{{ design }}</span>
    </div>
  </li>
</template>

<script lang="ts" setup>

import {HTMLPrinter} from "@k/global/htmlprinter";
import {
  insertCloudflareAutoformatIntoURLForStaticCDNURL,
  insertCloudflareDownscalingIntoURLForStaticCDNURLOnlyWidthAndContain
} from "@k/global/globalUtils";

const props = defineProps(
    {
      design: String,
      currentDesign: String,
      previewpath: String
    }
)

const designToLower = (name) => name.toLowerCase();
const getPreviewImageURL = designname => insertCloudflareDownscalingIntoURLForStaticCDNURLOnlyWidthAndContain(props.previewpath + ["design", (HTMLPrinter.removeSpaces(designname.toLowerCase())), "preview.png"].join("_"), 130);

</script>

<style lang="scss" scoped>
.km__design__product {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  justify-content: center;

  .km__design__product--preview {
    border: 2px solid $color-white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 67px;
    height: 67px;
    text-align: center;
  }

  .km__design__product--image {
    max-width: 100%;
    max-height: 100%;
  }

  .km__design__product--description {
    display: block;
    width: 67px;
    text-align: center;
    font-size: 11px;
  }
}

.km__modules__design--list {

  .km__list__element--modules {
    &.highlight {
      .km__design__product--preview {
        border: 2px solid $color-blue;
      }
    }
  }
}
</style>
